export const PRE_CHECKOUT_ORDER_STATUS_ENUM = {
    CREATED: 'created',
    PENDING: 'pending',
    PROCESSED: 'processed',
    ERROR: 'error',
    REJECT: 'reject',
};
